import { render } from "./WishlistView.vue?vue&type=template&id=085f46c2&scoped=true"
import script from "./WishlistView.vue?vue&type=script&lang=js"
export * from "./WishlistView.vue?vue&type=script&lang=js"

import "./WishlistView.vue?vue&type=style&index=0&id=085f46c2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085f46c2"]])

export default __exports__